import { z } from "zod";

/** Inpatient Phase 4 — CPOE: unified physician orders (non-medication). */

export const physicianOrderTypeSchema = z.enum([
	"lab",
	"imaging",
	"diet",
	"activity",
	"nursing",
	"consult",
	"other",
]);
export type PhysicianOrderType = z.infer<typeof physicianOrderTypeSchema>;

export const orderPrioritySchema = z.enum(["routine", "urgent", "stat"]);
export type OrderPriority = z.infer<typeof orderPrioritySchema>;

export const physicianOrderStatusSchema = z.enum([
	"active",
	"completed",
	"cancelled",
]);
export type PhysicianOrderStatus = z.infer<typeof physicianOrderStatusSchema>;

export const physicianOrderApiSchema = z.object({
	id: z.string().uuid(),
	admission_id: z.string().uuid(),
	order_type: z.string(),
	details: z.string(),
	priority: z.string(),
	status: z.string(),
	notes: z.string().nullable(),
	ordered_by_member_id: z.string().uuid().nullable(),
	ordered_at: z.string().datetime(),
	completed_by_member_id: z.string().uuid().nullable(),
	completed_at: z.string().datetime().nullable(),
	created_at: z.string().datetime(),
});
export type PhysicianOrderApi = z.infer<typeof physicianOrderApiSchema>;

export const createPhysicianOrderInputSchema = z.object({
	admission_id: z.string().uuid(),
	order_type: physicianOrderTypeSchema,
	details: z.string().min(1).max(2000),
	priority: orderPrioritySchema.optional(),
	notes: z.string().max(1000).nullable().optional(),
});
export type CreatePhysicianOrderInput = z.infer<
	typeof createPhysicianOrderInputSchema
>;
